






















import { computed, defineComponent } from '@vue/composition-api';
import { useInputTooltipShow } from '@tt4b/ttam-hooks';

export default defineComponent({
  name: 'InputTooltip',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: '',
    },
    shouldShowTooltip: {
      type: Boolean,
      default: true,
    },
    isError: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const url = computed(() => props.value);
    const { handleBlur, handleFocus, isShowInputTooltip } = useInputTooltipShow({ url });

    function handleInputBlur(e) {
      handleBlur();
      emit('blur', e);
    }

    function handleInputFocus(e) {
      handleFocus();
      emit('focus', e);
    }

    const isShowTooltip = computed(() => isShowInputTooltip.value && props.shouldShowTooltip);

    return {
      handleInputBlur,
      handleInputFocus,
      isShowTooltip,
    };
  },
});
